import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { setPricePoint } from 'src/actions/affordability'
import { selectPricePoint } from 'src/store/selectors/affordability'
import FormField from 'src/Components/FormField'
import DollarInput from 'src/Components/Input/DollarInput'
import Text from 'src/Components/Text'
import { FORM_FIELD_NAMES } from 'src/constants/affordability'
import PersistAffordabilityButton from 'src/features/buyers/Components/Global/AffordabilityModal/PersistAffordabilityButton'

import styles from './CustomPricePointTab.module.scss'

const StyledText = ({ className, ...restProps }) => (
  <Text
    element='span'
    className={classnames(styles.text, className)}
    {...restProps}
  />
)

const StyledInput = props => <DollarInput className={styles.input} {...props} />

const CustomPricePointTab = () => {
  const dispatch = useDispatch()
  const value = useSelector(selectPricePoint)

  return (
    <>
      <FormField.Dollars
        input={StyledInput}
        labelText={StyledText}
        labelClass={styles.label}
        name={FORM_FIELD_NAMES.PRICEPOINT}
        onChange={(e, value) => dispatch(setPricePoint(value))}
        value={value}
        required
      >
        <FormattedMessage
          id='Affordability.form.pricePoint'
          defaultMessage='Enter your price point'
        />
      </FormField.Dollars>
      <PersistAffordabilityButton className={styles.button} />
    </>
  )
}

export default CustomPricePointTab
